import { flow } from 'mobx-state-tree';
import { LoadableStatus } from '../loadable/loadable';

export const fetchParking = flow(function* (self, apiUrl, searchParams) {
  try {
    self.status = LoadableStatus.loading;

    const response = yield fetch(apiUrl, {
      body: JSON.stringify({
        lat: searchParams.lat,
        lng: searchParams.lon,
        hasEv: 0,
      }),
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    });

    const payload = yield response.json();

    if (response.status === 201) {
      payload.forEach((element) => {
        element.geometry.geometries = element.geometry.geometries[0];
      });
      self.setData(payload);
      self.status = LoadableStatus.done;
    }
  } catch (error) {
    console.error(error);
    self.status = LoadableStatus.error;
  }
});
